import { render, staticRenderFns } from "./TableV1.vue?vue&type=template&id=0a04849a&"
import script from "./TableV1.vue?vue&type=script&lang=js&"
export * from "./TableV1.vue?vue&type=script&lang=js&"
import style0 from "./TableV1.vue?vue&type=style&index=0&id=0a04849a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports